import { Component, computed, inject } from '@angular/core';
import { BasicBundleInfo } from '../../types/order.type';
import { Router } from '@angular/router';
import { EmptyMessageComponent } from '../../empty-message/empty-message.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SignalsStoreService } from '../../signals-store.service';
import { getProductSubscriptioninfo, openModalUnskipProduct } from '../../common/subscriptions.utils';
import { ModalContentService } from '../modal-content.service';
import { SubscriptionsService } from '../../../settings/account/subscriptions/subscriptions.service';
import { OrderService } from '../../order.service';

@Component({
  selector: 'app-bundles-subscription',
  imports: [
    EmptyMessageComponent
  ],
  templateUrl: './bundles-subscription.component.html',
  styleUrl: './bundles-subscription.component.scss'
})
export class BundlesSubscriptionComponent {

  //#region Services

  #router = inject(Router);

  #activeModal = inject(NgbActiveModal);

  #signalsStoreService = inject(SignalsStoreService);

  #modalContentService = inject(ModalContentService);

  #subscriptionsService = inject(SubscriptionsService);

  #orderService = inject(OrderService);

  //#endregion

  //#region Properties

  bundles = computed(() => this.#signalsStoreService.getBundlesLikeSubscriptions());

  //#endregion

  //#region Methods

  goToCustomBox(bundle: BasicBundleInfo) {
    this.#activeModal.close();
    this.#router.navigate([`/shop/custom-box/subscription/${bundle.id}`]);
  }

  handleImageError(event: Event) {
    (event.target as HTMLImageElement).src = 'assets/images/product-placeholder.webp';
  }

  unskipBundle(bundle: BasicBundleInfo) {
    const subscription = getProductSubscriptioninfo(this.#signalsStoreService.subscriptions(), bundle.id);
    if (!subscription) return
    this.#activeModal.close();
    openModalUnskipProduct({
      sub: subscription,
      modalContentService: this.#modalContentService,
      subscriptionsService: this.#subscriptionsService,
      router: this.#router,
      goToCustomizeBundle: true
    });
  }

  //#endregion
}
